



















import { Vue, Component, Prop, Emit, Model } from 'vue-property-decorator'
import TableColumnButton, { Button, ButtonModel } from './TableColumnButton.vue'
import { randKey } from '@/utils/random'
import { ElementUIComponentSize } from 'element-ui/types/component'

export interface ButtonGroup {
  type: 'buttonGroup'
  group: ButtonModel[]
  style?: 'group' | 'single'
  size?: ElementUIComponentSize
}

@Component({
  components: { TableColumnButton }
})
export default class TableColumnButtonGroup extends Vue {
  @Prop({ type: Object, required: true }) type!: ButtonGroup
  randKey = randKey()

  get group(): Button[] {
    return this.type.group.map(a => {
      return {
        ...a,
        type: 'button',
        size: this.type.size
      }
    })
  }
}
